import { render } from "./StoreSummaryResults2.vue?vue&type=template&id=8520c690&scoped=true&lang=pug"
import script from "./StoreSummaryResults2.vue?vue&type=script&lang=js"
export * from "./StoreSummaryResults2.vue?vue&type=script&lang=js"

import "./StoreSummaryResults2.vue?vue&type=style&index=0&id=8520c690&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8520c690"]])

export default __exports__